import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11de2329"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "createRecord" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "新建上课记录", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" (单位：课时，可填写小数) ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 确定 ")

import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { createRecord } from "../../config/interface";
import type { ElForm } from "element-plus";
import { ElMessage } from "element-plus";
type FormInstance = InstanceType<typeof ElForm>;


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const ruleFormRef = ref<FormInstance>();
const router = useRouter();
const route = useRoute();
let back = "<";
const insertLoading = ref(false);
let recordInfo = ref<any>({});
// 表单校验规则
const rules = {
  recordName: [
    { required: true, message: "请输入本次记录名称", trigger: "blur" },
  ],
  classNum: [
    { required: true, message: "请输入本次记录上课时长", trigger: "blur" },
  ],
};

const handleCreateRecord = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.validate((valid) => {
    if (valid) {
      insertLoading.value = true;
      let params = {
        coId: route.query.coId,
        classNum: recordInfo.value.classNum,
        recordName: recordInfo.value.recordName,
      };
      createRecord(params).then((res) => {
        console.log(res);
        if (res.data.data && res.data.success) {
          insertLoading.value = false;
          ElMessage.success("新建上课记录成功");
          router.push({
            path: "/order/studentEdit",
            query: {
              crId: res.data.data,
            },
          });
        } else {
          ElMessage.error(res.data.msg);
        }
      });
    } else {
      console.log("error submit!");
      return false;
    }
  });
};
const handleBack = () => {
  router.back();
};
onMounted(() => {
  console.log(route.query.coId);
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "back",
        onClick: handleBack
      }, _toDisplayString(_unref(back)) + " 返回", 1)
    ]),
    _hoisted_3,
    _createVNode(_component_el_form, {
      ref_key: "ruleFormRef",
      ref: ruleFormRef,
      rules: rules,
      model: _unref(recordInfo),
      "label-width": "100px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "记录名称",
          prop: "recordName"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(recordInfo).recordName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(recordInfo).recordName) = $event)),
              placeholder: "请输入本次记录的名称，以便区分",
              style: {"width":"300px"}
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "上课时长",
          prop: "classNum"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(recordInfo).classNum,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(recordInfo).classNum) = $event)),
              placeholder: "请输入本次上课记录的课时",
              style: {"width":"300px"}
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_button, {
              type: "text",
              size: "small",
              style: {"margin-left":"10px"}
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dialogVisible = false))
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              type: "primary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (handleCreateRecord(ruleFormRef.value)))
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })), [
              [
                _directive_loading,
                insertLoading.value,
                void 0,
                {
                  fullscreen: true,
                  lock: true
                }
              ]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})